import { __ } from "@wordpress/i18n";
import { useSettingsContext } from "../../../../hook/useSettingsContext";
import { useSpacingObject } from "../../../../hook/useSpacingObject";
import SettingsForm from "../../SettingsForm";
import FieldWrapper from "../../../../components/UI/common/FieldWrapper";
import Wrapper from "../../../../components/UI/common/Wrapper";
import Input from "../../../../components/UI/Input";
import NumberUnit from "../../../../components/UI/NumberUnit";
import Select from "../../../../components/UI/Select";
import ButtonSet from "../../../../components/UI/ButtonSet";
import SpaceControl from "../../../../components/UI/SpaceControl";

export default function PrefixSuffixSettings() {
    const {
        settings,
        getSection,
        getOption,
        handleInputChange,
        handleSpaceControlChange,
    } = useSettingsContext();

    const sectionID = "prefixsuffix";
    const section = getSection(sectionID);
    const prefixMargin = useSpacingObject(getOption("prefixMargin", sectionID));
    const suffixMargin = useSpacingObject(getOption("suffixMargin", sectionID));

    // console.log(settings);

    return (
        <SettingsForm
            title={__(
                "Prefix & Suffix Settings",
                "wpbean-quantity-controls-for-woocommerce",
            )}
            subtitle={__(
                "Customize quantity button prefix & suffix.",
                "wpbean-quantity-controls-for-woocommerce",
            )}
        >
            <FieldWrapper
                label={__("Prefix", "wpbean-quantity-controls-for-woocommerce")}
                description={__(
                    "Prefix text for the quantity buttons can be added here.",
                )}
                width="100"
                containerClass="grid grid-cols-1 lg:grid-cols-2 lg:items-center lg:gap-10 gap-4"
            >
                <Input
                    name="prefixText"
                    value={getOption("prefixText", sectionID)}
                    onChange={(key, value) =>
                        handleInputChange(section, key, value)
                    }
                />
            </FieldWrapper>

            <FieldWrapper
                label={__("Suffix", "wpbean-quantity-controls-for-woocommerce")}
                description={__(
                    "Suffix text for the quantity buttons can be added here.",
                )}
                width="100"
                containerClass="grid grid-cols-1 lg:grid-cols-2 lg:items-center lg:gap-10 gap-4"
            >
                <Input
                    name="suffixText"
                    value={getOption("suffixText", sectionID)}
                    onChange={(key, value) =>
                        handleInputChange(section, key, value)
                    }
                />
            </FieldWrapper>
            <FieldWrapper
                label={__(
                    "Alignment",
                    "wpbean-quantity-controls-for-woocommerce",
                )}
                description={__("Prefix & suffix text alignment.")}
                width="100"
                containerClass="grid grid-cols-1 lg:grid-cols-2 lg:items-center lg:gap-10 gap-4"
            >
                <ButtonSet
                    name="prefixAlignment"
                    value={getOption("prefixAlignment", sectionID)}
                    onChange={(key, value) =>
                        handleInputChange(section, key, value)
                    }
                    allowDeselect
                    options={[
                        {
                            value: "left",
                            label: __(
                                "Left",
                                "wpbean-quantity-controls-for-woocommerce",
                            ),
                        },
                        {
                            value: "center",
                            label: __(
                                "Center",
                                "wpbean-quantity-controls-for-woocommerce",
                            ),
                        },
                        {
                            value: "right",
                            label: __(
                                "Right",
                                "wpbean-quantity-controls-for-woocommerce",
                            ),
                        },
                    ]}
                />
            </FieldWrapper>

            <Wrapper
                title={__(
                    "Typography Options",
                    "wpbean-quantity-controls-for-woocommerce",
                )}
                description={__(
                    "You can adjust the prefix & suffix typography here.",
                    "wpbean-quantity-controls-for-woocommerce",
                )}
            >
                <>
                    <FieldWrapper
                        label={__(
                            "Font Size",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        help={__(
                            "Prefix & suffix font size, Can be in any CSS unit.",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        type="number-unit"
                        width="30"
                        containerClass="flex justify-between items-center lg:gap-10 gap-4"
                        fieldsClass=""
                    >
                        <NumberUnit
                            value={getOption("prefixFontSize", sectionID)}
                            onChange={(value) =>
                                handleInputChange(
                                    section,
                                    "prefixFontSize",
                                    value,
                                )
                            }
                        />
                    </FieldWrapper>

                    <FieldWrapper
                        label={__(
                            "Font Weight",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        help={__(
                            "Prefix & suffix font weight.",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        width="36"
                        containerClass="flex justify-between items-center lg:gap-10 gap-4"
                        fieldsClass=""
                    >
                        <Select
                            placeholder={__(
                                "Select an option",
                                "wpbean-quantity-controls-for-woocommerce",
                            )}
                            name="prefixFontWeight"
                            value={getOption("prefixFontWeight", sectionID)}
                            onChange={(key, value) =>
                                handleInputChange(section, key, value)
                            }
                            options={[
                                {
                                    value: "100",
                                    label: __(
                                        "100",
                                        "wpbean-quantity-controls-for-woocommerce",
                                    ),
                                },
                                {
                                    value: "200",
                                    label: __(
                                        "200",
                                        "wpbean-quantity-controls-for-woocommerce",
                                    ),
                                },
                                {
                                    value: "300",
                                    label: __(
                                        "300",
                                        "wpbean-quantity-controls-for-woocommerce",
                                    ),
                                },
                                {
                                    value: "400",
                                    label: __(
                                        "400",
                                        "wpbean-quantity-controls-for-woocommerce",
                                    ),
                                },
                                {
                                    value: "500",
                                    label: __(
                                        "500",
                                        "wpbean-quantity-controls-for-woocommerce",
                                    ),
                                },
                                {
                                    value: "600",
                                    label: __(
                                        "600",
                                        "wpbean-quantity-controls-for-woocommerce",
                                    ),
                                },
                                {
                                    value: "700",
                                    label: __(
                                        "700",
                                        "wpbean-quantity-controls-for-woocommerce",
                                    ),
                                },
                                {
                                    value: "800",
                                    label: __(
                                        "800",
                                        "wpbean-quantity-controls-for-woocommerce",
                                    ),
                                },
                                {
                                    value: "900",
                                    label: __(
                                        "900",
                                        "wpbean-quantity-controls-for-woocommerce",
                                    ),
                                },
                            ]}
                        />
                    </FieldWrapper>
                </>
            </Wrapper>
            <div className="grid rounded-lg border border-gray-100 p-4 lg:gap-10 gap-6">
                <FieldWrapper
                    label={__(
                        "Prefix Margin",
                        "wpbean-quantity-controls-for-woocommerce",
                    )}
                    description={__(
                        "You can adjust the prefix margin here.",
                        "wpbean-quantity-controls-for-woocommerce",
                    )}
                    type="box-control"
                    width="100"
                    containerClass="grid grid-cols-1 lg:grid-cols-2 lg:items-center lg:gap-10 gap-4"
                >
                    <SpaceControl
                        value={prefixMargin}
                        onChange={(values) =>
                            handleSpaceControlChange(
                                values,
                                section,
                                "prefixMargin",
                            )
                        }
                    />
                </FieldWrapper>
                <FieldWrapper
                    label={__(
                        "Suffix Margin",
                        "wpbean-quantity-controls-for-woocommerce",
                    )}
                    description={__(
                        "You can adjust the suffix margin here.",
                        "wpbean-quantity-controls-for-woocommerce",
                    )}
                    type="box-control"
                    width="100"
                    containerClass="grid grid-cols-1 lg:grid-cols-2 lg:items-center lg:gap-10 gap-4"
                >
                    <SpaceControl
                        value={suffixMargin}
                        onChange={(values) =>
                            handleSpaceControlChange(
                                values,
                                section,
                                "suffixMargin",
                            )
                        }
                    />
                </FieldWrapper>
            </div>
        </SettingsForm>
    );
}
